import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { CTabContent, CSidebar } from '@coreui/react-pro'
import { selectAsideShow, setAsideShow } from '../reducers/layoutReducer'

const AppAside = () => {
  const dispatch = useDispatch()
  const asideShow = useSelector(selectAsideShow)
  return (
    <CSidebar
      colorScheme="light"
      size="lg"
      overlaid
      placement="end"
      visible={asideShow}
      onVisibleChange={(visible) => {
        dispatch(setAsideShow(visible))
      }}
    >
      <CTabContent></CTabContent>
    </CSidebar>
  )
}

export default React.memo(AppAside)
